import How from "./How";

export default How;
